// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#articles,#description,#events,#photos,#providers,#routes,#technical-infos{\n  scroll-margin-top:254px\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
